export const tr = {
    'other-sign': 've {number} daha',
    'page-name': 'Engellenen siteler'
};
